function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty } from "lodash";
import React from "react";
import { connect } from "react-redux";
import { SUBSCRIPTION_ACTIVE, SUBSCRIPTION_NON_RENEWING } from "@config/constants";
/**
 *
 * @param {{
 *  status: string
 *  statusText: string
 *  additionalText: string
 * }} props
 * @returns
 */ export var ActivityIndicator = function(props) {
    var _props_status = props.status, status = _props_status === void 0 ? SUBSCRIPTION_ACTIVE : _props_status, i18n = props.i18n, additionalText = props.additionalText;
    var _obj;
    var translatedStatusMap = (_obj = {}, _define_property(_obj, SUBSCRIPTION_ACTIVE, i18n.account.statusActive), _define_property(_obj, SUBSCRIPTION_NON_RENEWING, i18n.account.statusDeactivated), _obj);
    var statusText = props.statusText;
    if (isEmpty(statusText)) {
        statusText = translatedStatusMap[status];
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "activity-wrapper ".concat(status),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "column text-wrapper",
                children: [
                    additionalText && /*#__PURE__*/ _jsx("div", {
                        className: "additional-text",
                        children: additionalText
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "status-text",
                        children: statusText
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "icon icon-done check"
            })
        ]
    });
};
var mapStateToProps = function(param) {
    var i18n = param.i18n;
    return {
        i18n: i18n
    };
};
var mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(ActivityIndicator);
